import {
  AppointmentTypeKind,
  DayOfWeek,
} from "@scrile/api-provider/dist/projects/scrileConnect/AppointmentTypeProvider";
import { $t } from "@/lib/i18nHelpers";
import weekLocaleHelper from "@/lib/weekLocaleHelpers";
import { Tab } from "@/types";

const { firstDayOfWeek, weekDaysToReorder } = weekLocaleHelper();

export const onlineAppointmentKinds = [
  AppointmentTypeKind.MESSAGING,
  AppointmentTypeKind.AUDIO_CALLS,
  AppointmentTypeKind.VIDEO_CALLS,
];

const getDayOfWeekTabs = () => {
  const days = Object.keys(DayOfWeek).filter(day => day !== DayOfWeek.ALL);
  const tabs: Tab[] = [];

  days.forEach(day => {
    tabs.push({
      text: $t(day)
        .toUpperCase()
        .slice(0, 1),
      value: DayOfWeek[day as keyof typeof DayOfWeek],
      order: weekDaysToReorder.includes(day.toLowerCase()) ? -1 : undefined,
    });
  });

  return tabs;
};

export const daysOfWeekTabs: Tab[] = getDayOfWeekTabs();
export const weekStart = DayOfWeek[firstDayOfWeek.toUpperCase() as keyof typeof DayOfWeek];
